import BaseModule from "@core/modules/base-module/base-module";
import NewsCard from "@core/components/cards/news-card/news-card";

const highlightedNewsHome = new BaseModule();
highlightedNewsHome.name = "highlighted-news-home";
highlightedNewsHome.init((that)=>{
  const card=new NewsCard(that.elements);
  card.init();
});
